import { TReduxActions } from '../../../types/redux';
import { EOpenNewQuestionForm } from '../../../actions/newQuestion';

export const defaultValue = false;

export function openReducer(state: boolean = defaultValue, { type }: TReduxActions): boolean {
  if (type === EOpenNewQuestionForm.Open) {
    return true;
  }

  if (type === EOpenNewQuestionForm.Close) {
    return false;
  }

  return state;
}
